import React from 'react';
import "../style/style.css";


const VideoDetail = ({video}) => {
  if(!video) {
    return <div className="empty-search col-md-12">
        <p>Search for any YouTube videos</p>
      </div>;
  }
  const videoId = video.id.videoId;
  const url = `https://www.youtube.com/embed/${videoId}`;
return (

  <div className="col-md-8 video-detail ">
    <div className="embed-responsive embed-responsive-16by9">
      <iframe className="embed-responsive-item" src={url} title="youtube">
      </iframe>
    </div>

  <div className="details ">
    <div> {video.snippet.title} </div>
    <div> {video.snippet.description} </div>
  </div>
  </div>

);
};

export default VideoDetail;
